<template>
  <div>
    <dialogos-app :dialogos="dialogos" :personaje="false"></dialogos-app>
    <v-layout class="wrap-md-and-down" align-center="" justify-center="">
      <v-flex class="flex-img">
        <img src="../../assets/presentacion/diapositiva-2.png" alt="instructor">
      </v-flex>
      <v-flex pl-4>
        <router-link to="/modulo2/0" class="modulo"><span class="wrapper wrapper-2"><span class="numero_modulo">M2</span></span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 2:</span> Clasificación de las reservas</span></router-link>
      </v-flex>
    </v-layout>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 16'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "¡Felicitaciones! Has finalizado el módulo con éxito. Te invito a continuar el siguiente. <span class='instruccion'>Haz clic en el icono.</span>" 
      ],
      preguntas: []
    }
  },
  created() {
    this.$store.commit('nextShow', false)
    this.preguntas = require('../../assets/Modulo 1/diapositiva-14.json');
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/helpers/moduleButtons';
</style>
